import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Layout } from '../components/Layout';
import { Button } from '../components/ui/Button';
import { ArrowLeftIcon, CalendarIcon, UserIcon } from 'lucide-react';
const articles: Record<string, {
  title: string;
  date: string;
  author: string;
  category: string;
  image: string;
  content: string[];
}> = {
  '4': {
    title: 'Retour sur le 1er Atelier National ADCC : 41 participants, 8 modules, une ambition',
    date: '16 Mar 2026',
    author: 'Équipe ADCC',
    category: 'Formation',
    image: 'https://cdn.magicpatterns.com/uploads/opPxzmWiMSRTC4qTrQ2YSj/WhatsApp_Image_2026-03-16_at_14.07.52_(3).jpg',
    content: ["Du 12 au 14 mars, l'ADCC a organisé son tout premier atelier national de renforcement des capacités dédié aux métiers de l'entretien et de la maintenance, réunissant 41 participants autour d'un objectif clair : professionnaliser un secteur à fort potentiel d'emploi au Bénin.", "Le lancement officiel s'est tenu le 12 mars à l'hôtel Azalaï de Cotonou, en présence de plusieurs acteurs institutionnels et partenaires clés, notamment la Mairie de Cotonou, Care International Bénin, l'Institut National de la Femme, ainsi que des structures de placement telles que O2 Bénin et Wiston Services. Cette cérémonie a permis de présenter la vision et les ambitions de l'ADCC, de sensibiliser à l'importance de structurer les métiers de services et de renforcer les synergies entre les acteurs de l'emploi et de l'insertion professionnelle.", "Les 13 et 14 mars, les activités se sont poursuivies à Bamboo Numérique dans une ambiance dynamique, participative et conviviale. Les participants ont bénéficié d'une formation intensive articulée autour de huit modules complémentaires, animés par des experts engagés : le nettoyage professionnel (Mahambi Moussa), l'entretien des vêtements et textiles (Gisèle ATCHADE), le rangement et l'organisation (Bill Isaac AGBANGLA), les droits et devoirs du travailleur (Jean Apôtre OBOSSOU), l'attitude et le comportement professionnel (Fidèle ADJOVI), la gestion de carrière et la recherche d'emploi (Arthur FREUD SEGNON), la conception de CV et le pitch professionnel (Serge KOUOH), ainsi que la sensibilisation aux violences faites aux femmes (Maître ATADE TOPANOU). Cette diversité de contenus a permis d'aborder à la fois les compétences techniques, les compétences comportementales et les enjeux sociaux liés à ces métiers, avec une approche résolument pratique et orientée terrain.", "Au-delà des apprentissages, cet atelier visait à renforcer l'employabilité des participants, à valoriser des métiers essentiels mais encore insuffisamment reconnus, et à créer une dynamique de réseau entre bénéficiaires et partenaires. À l'issue des deux journées de formation, les participants ont reçu une attestation de participation, marquant la reconnaissance de leur engagement et le début d'un parcours de professionnalisation.", "À travers cette initiative, l'ADCC pose les bases d'une action structurante pour le développement des métiers de l'entretien au Bénin, avec l'ambition de renforcer, professionnaliser et insérer durablement les talents locaux."]
  },
  '1': {
    title: "Forum Fondateur : L'ADCC à l'écoute des personnels de maison",
    date: '10 Jan 2026',
    author: 'Équipe ADCC',
    category: 'Article',
    image: 'https://cdn.magicpatterns.com/uploads/exRoSvgKroC4rrK6KpbESt/WhatsApp_Image_2026-01-29_at_17.21.09.jpg',
    content: ["L'Association Dignité Compétence Création (ADCC) a organisé son tout premier forum d'état des lieux, réunissant une dizaine de personnels de maison venus de différents horizons professionnels : entretien ménager, cuisine, garde d'enfants, gardiennage...", 'Avant de lancer nos programmes de formation, nous avons voulu comprendre. Comprendre les réalités quotidiennes, les difficultés rencontrées, les aspirations de celles et ceux que nous souhaitons accompagner.', "Un besoin réel en compétences professionnelles : beaucoup exercent sans avoir reçu de formation structurée, apprenant « sur le tas ». Une demande de reconnaissance : les métiers de service à la personne souffrent d'un manque de considération sociale. L'importance de l'accompagnement : trouver un emploi est une chose, le garder dans de bonnes conditions en est une autre.", "Ce forum a posé les fondations de notre approche : écouter d'abord, agir ensuite. Les enseignements tirés de cette rencontre guident aujourd'hui la conception de nos ateliers de formation prévus pour mars 2026.", 'Merci à tous les participants qui ont accepté de partager leur vécu avec nous. Ensemble, nous construisons un avenir plus digne pour les personnels de maison au Bénin.']
  }
};
export function ArticlePage() {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const article = id ? articles[id] : null;
  if (!article) {
    return <Layout data-id="element-563">
        <div className="min-h-[60vh] flex flex-col items-center justify-center px-4" data-id="element-564">
          <h1 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-565">
            Article introuvable
          </h1>
          <p className="text-gray-600 mb-6" data-id="element-566">
            Cet article n'existe pas ou a été déplacé.
          </p>
          <Link to="/blog" data-id="element-567">
            <Button className="gap-2" data-id="element-568">
              <ArrowLeftIcon className="w-4 h-4" data-id="element-569" />
              Retour au blog
            </Button>
          </Link>
        </div>
      </Layout>;
  }
  return <Layout data-id="element-570">
      {/* Hero Image */}
      <div className="relative w-full h-[350px] md:h-[450px]" data-id="element-571">
        <img src={article.image} alt={article.title} className="w-full h-full object-cover" data-id="element-572" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" data-id="element-573" />
        <div className="absolute bottom-0 left-0 right-0 p-6 md:p-10" data-id="element-574">
          <div className="max-w-3xl mx-auto" data-id="element-575">
            <span className="inline-block bg-[#1E88E5] text-white text-xs font-bold uppercase tracking-wide px-3 py-1 rounded-full mb-3" data-id="element-576">
              {article.category}
            </span>
            <h1 className="text-2xl md:text-4xl font-bold text-white leading-tight" data-id="element-577">
              {article.title}
            </h1>
          </div>
        </div>
      </div>

      {/* Article Content */}
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-id="element-578">
        {/* Meta */}
        <div className="flex items-center text-gray-500 text-sm mb-8 space-x-4 border-b border-gray-200 pb-6" data-id="element-579">
          <div className="flex items-center gap-1.5" data-id="element-580">
            <CalendarIcon className="w-4 h-4" data-id="element-581" />
            {article.date}
          </div>
          <div className="flex items-center gap-1.5" data-id="element-582">
            <UserIcon className="w-4 h-4" data-id="element-583" />
            {article.author}
          </div>
        </div>

        {/* Body */}
        <div className="space-y-6" data-id="element-584">
          {article.content.map((paragraph, index) => <p key={index} className={`text-gray-700 leading-relaxed ${index === 0 ? 'text-lg font-medium text-gray-900' : ''}`} data-id="element-585">
              {paragraph}
            </p>)}
        </div>

        {/* Back to blog */}
        <div className="mt-12 pt-8 border-t border-gray-200" data-id="element-586">
          <Link to="/blog" data-id="element-587">
            <Button variant="secondary" className="gap-2" data-id="element-588">
              <ArrowLeftIcon className="w-4 h-4" data-id="element-589" />
              Retour au blog
            </Button>
          </Link>
        </div>
      </div>
    </Layout>;
}